 

const mutations = {
  SET_VOLATILITY_LARGE(state, payload) {
    if (payload.volatilityLargeChart) {
      if (payload.volatilityLargeChart.chart) {
        state.volatilityLargeChart = payload.volatilityLargeChart.chart;
        if (payload.volatilityLargeChart.output && payload.volatilityLargeChart.output !== '--') {
          state.volatilityLargeData = JSON.parse(payload.volatilityLargeChart.output);
        }
      } else {
        state.volatilityLargeChart = payload.volatilityLargeChart;
      }
    }
  }
};

const getters = {
  volatilityLargeChart: state => state.volatilityLargeChart,
  volatilityLargeData: state => state.volatilityLargeData
};

const state = {};
state.volatilityLargeChart = '';
state.volatilityLargeData = {};

export default {
  state,
  getters,
  mutations
};
